<h4 class="text-center"> Base Rate </h4>

<div *ngIf="update_success" class="alert alert-info text-center mb-3"> Update Success</div>
<form [formGroup]="baseRateForm" (ngSubmit)="on_submit()" *ngIf="!loading">
  <div class="form-group row" [ngClass]="{error:f.week.errors && f.week.touched}">
        <label for="week" class='control-label col-sm-3'>Week (UGX)
          <span class="required-asteric">*</span>
        </label>
        <div class="input-group controls col-sm-8">
          <input type="text" id="week" formControlName="week" class="form-control">
        </div>
        <div *ngIf="f.week.errors && f.week.touched">
          <ul>
            <li>Weekly Amount is Required.</li>
          </ul>
        </div>
      </div>
      <div class="form-group row" [ngClass]="{error:f.month.errors && f.month.touched}">
        <label for="month" class='control-label col-sm-3'>Month (UGX)
          <span class="required-asteric">*</span>
        </label>
        <div class="input-group controls col-sm-8">
          <input type="text" id="month" formControlName="month" class="form-control">
        </div>
        <div *ngIf="f.month.errors && f.month.touched">
          <ul>
            <li>Monthly Amount is  Required.</li>
          </ul>
        </div>
      </div>
      <div class="form-group row" [ngClass]="{error:f.year.errors && f.year.touched}">
        <label for="year" class='control-label col-sm-3'>Year (UGX)<span class="required-asteric">*</span></label>
        <div class="input-group controls col-sm-8">
          <input type="text" id="year" formControlName="year" class="form-control">
        </div>
        <div *ngIf="f.year.errors && f.year.touched">
          <ul>
            <li>Year Amount is required.</li>
          </ul>
        </div>
      </div>

  <fieldset class="buttons text-center">
    <button type="submit" class="btn btn-primary margin-50-right">Submit</button>
    <a *ngIf="authService.isGranted('ROLE_ADMIN')" [routerLink]="['/admin/billing/index']" class="btn btn-danger">Close</a>
  </fieldset>
</form>

